import React from 'react'
import classnames from 'classnames'
import css from './QuickAddButton.styles.scss'
import IconButton from 'baby-design/components/IconButton/IconButton'
import Plus from 'baby-design/icons/Plus.svg'

interface QuickAddButtonProps {
  show?: boolean
  onClick?: (e: React.MouseEvent) => void
}

const QuickAddButton: React.FC<QuickAddButtonProps> = ({
  show = true,
  onClick = () => {},
}) => {
  return (
    <div
      data-testid="quick-add-button"
      onClick={onClick}
      className={classnames(
        css['QuickAddButton'],
        css[`QuickAddButton${show ? '--show' : ''}`]
      )}
    >
      <IconButton
        className={css['QuickAddButton__button']}
        variant="fill-secondary"
        size="lg"
      >
        <Plus className={css['QuickAddButton__icon']} />
      </IconButton>
    </div>
  )
}

export default QuickAddButton
